function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { SsaiStitcherType, TrackingEventType } from '../../addons/adverts/common';
import { PixelFetch } from '../../addons/adverts/pixel-fetch';
import { ErrorSeverity } from '../../error';
import { sdkLogger } from '../../logger';
export var AdsTrackingController = /*#__PURE__*/ function() {
    "use strict";
    function AdsTrackingController(adEventsManager, session) {
        var _this = this;
        _class_call_check(this, AdsTrackingController);
        _define_property(this, "adEventsManager", void 0);
        _define_property(this, "currentAdBreakId", void 0);
        _define_property(this, "currentAdKey", void 0);
        _define_property(this, "pixelFetch", void 0);
        _define_property(this, "adTrackingReceived", void 0);
        _define_property(this, "cachedBeacons", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "handleError", void 0);
        _define_property(this, "fireBeacon", void 0);
        this.adEventsManager = adEventsManager;
        this.currentAdBreakId = null;
        this.currentAdKey = null;
        this.adTrackingReceived = false;
        this.cachedBeacons = [];
        this.logger = sdkLogger.withContext(this.constructor.name);
        this.handleError = function(error) {
            if (!error || error.severity !== ErrorSeverity.Fatal) {
                return;
            }
            var errorMessage = "".concat(error.code || 'unknown', " - ").concat(error.message);
            var errorCode = '900';
            // "Unidentified". TODO: Add mappings for error codes in VAST spec.
            var currentAdBreak = _this.currentAdBreakId ? _this.adEventsManager.getAdBreak(_this.currentAdBreakId) : null;
            var currentAd = _this.currentAdKey ? _this.adEventsManager.getAd(_this.currentAdKey) : null;
            if (currentAdBreak) {
                currentAdBreak.trackingEvents.filter(function(e) {
                    return e.type === TrackingEventType.Error;
                }).forEach(function(errorTrackingEvent) {
                    var url = errorTrackingEvent.url.replace('[ERROR_MESSAGE]', encodeURIComponent(errorMessage)).replace('[ERROR_CODE]', errorCode);
                    // TODO: See if we can track any other error scenarios https://www.iab.com/wp-content/uploads/2015/06/VMAPv1_0.pdf
                    _this.pixelFetch.fetch(url);
                });
                _this.currentAdBreakId = null;
            }
            if (currentAd) {
                currentAd.trackingEvents.filter(function(e) {
                    return e.type === TrackingEventType.Error;
                }).forEach(function(errorTrackingEvent) {
                    var url = errorTrackingEvent.url.replace('[ERRORCODE]', encodeURIComponent(errorCode));
                    _this.pixelFetch.fetch(url);
                });
            }
        };
        this.fireBeacon = function(param) {
            var adBreakId = param.adBreakId, beaconUrl = param.beaconUrl, beaconType = param.beaconType, force = param.force;
            if (!_this.adTrackingReceived && !force) {
                _this.cachedBeacons.push({
                    adBreakId: adBreakId,
                    beaconUrl: beaconUrl,
                    beaconType: beaconType
                });
                return;
            }
            _this.pixelFetch.fetch(beaconUrl);
            _this.logger.verbose("[ADS] ".concat(beaconType, " beacon"), beaconUrl);
        };
        this.pixelFetch = new PixelFetch(self);
        adEventsManager.onAdTrackingReceived(this.handleAdTrackingReceived.bind(this), this);
        adEventsManager.onAdEvent(this.handleAdEvent.bind(this), this);
        adEventsManager.onAdBreakStarted(this.handleAdBreakStart.bind(this), this);
        adEventsManager.onAdBreakFinished(this.handleAdBreakFinished.bind(this), this);
        session.onError(this.handleError);
    }
    _create_class(AdsTrackingController, [
        {
            key: "handleAdTrackingReceived",
            value: function handleAdTrackingReceived() {
                var _this = this;
                this.adTrackingReceived = true;
                this.cachedBeacons.forEach(function(beacon) {
                    _this.fireBeacon(_object_spread_props(_object_spread({}, beacon), {
                        force: false
                    }));
                });
                this.cachedBeacons = [];
            }
        },
        {
            key: "handleAdEvent",
            value: function handleAdEvent(event) {
                var _this = this;
                if (!event.ad.trackingEvents || event.adBreak.watched) {
                    return;
                }
                switch(event.event){
                    case TrackingEventType.AdStart:
                        this.currentAdKey = event.adKey;
                        break;
                    case TrackingEventType.AdFinished:
                        this.currentAdKey = null;
                        break;
                }
                event.ad.trackingEvents.filter(function(trackingEvent) {
                    return trackingEvent.type === event.event;
                }).forEach(function(trackingEvent) {
                    return _this.fireBeacon({
                        adBreakId: event.ad.adBreakId,
                        beaconUrl: trackingEvent.url,
                        beaconType: trackingEvent.type,
                        force: event.adBreak.ssaiStitcherType === SsaiStitcherType.None
                    });
                });
            }
        },
        {
            key: "handleAdBreakStart",
            value: function handleAdBreakStart(adBreak) {
                this.currentAdBreakId = adBreak.id;
                this.handleAdBreakEvent(adBreak, TrackingEventType.BreakStart);
            }
        },
        {
            key: "handleAdBreakFinished",
            value: function handleAdBreakFinished(adBreak) {
                this.currentAdBreakId = null;
                this.handleAdBreakEvent(adBreak, TrackingEventType.BreakEnd);
            }
        },
        {
            key: "handleAdBreakEvent",
            value: function handleAdBreakEvent(adBreak, event) {
                var _this = this;
                if (!adBreak.trackingEvents || adBreak.watched) {
                    return;
                }
                adBreak.trackingEvents.filter(function(trackingEvent) {
                    return trackingEvent.type === event;
                }).forEach(function(trackingEvent) {
                    _this.fireBeacon({
                        adBreakId: adBreak.id,
                        beaconUrl: trackingEvent.url,
                        beaconType: trackingEvent.type,
                        // Some ads may come from non SSAI services (SLE Preroll for example)
                        // For these non-SSAI ads, we don't want to defer sending of beacons
                        force: adBreak.ssaiStitcherType === SsaiStitcherType.None
                    });
                });
            }
        }
    ]);
    return AdsTrackingController;
}();

//# sourceMappingURL=ads-tracking-controller.js.map